import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = ({className, width, height, fill}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 59 59" xmlns="http://www.w3.org/2000/svg">
      <title>Edit</title>
      <path fill={fill} fillRule="evenodd" d="M36.3 10.188l11.684 11.74-29.575 29.72-11.677-11.74L36.3 10.188zm20.55-2.832L51.64 2.12a5.153 5.153 0 0 0-7.305 0l-4.99 5.016 11.683 11.74 5.822-5.85a4.017 4.017 0 0 0 0-5.67zM.618 56.41c-.213.962.651 1.824 1.608 1.59l13.02-3.172L3.569 43.087.618 56.41z"/>
    </svg>
  )
}

EditIcon.defaultProps = {
  className: '',
  width: '59px',
  height: '59px',
  fill: '#666'
}

EditIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
}

export default EditIcon;